module.exports = __webpack_public_path__ + "img/logo.93b37267.png";